import { Box, Chip, useMediaQuery, useTheme } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

// renders an empty diagram for streams without data in the current scope
export default function WeatherFilters({ streamDefs, streams, onToggle, onSolo }) {

    const { t } = useTranslation()

    const theme = useTheme()
    const is2k = useMediaQuery('(min-width:1920px)')
    const isXxl = useMediaQuery('(min-width:1700px)')
    const isXl = useMediaQuery(theme.breakpoints.up('xl'))
    const isLg = useMediaQuery(theme.breakpoints.up('lg'))
    const isMd = useMediaQuery(theme.breakpoints.up('md'))
    const isSm = useMediaQuery(theme.breakpoints.up('sm'))
    const isXs = useMediaQuery('(min-width:480px)')
    const isXxs = useMediaQuery('(min-width:340px)')
    const cols = Math.min(streamDefs.length, is2k ? 8 : isXxl ? 7 : isXl ? 6 : isLg ? 5 : isMd ? 3 : isSm ? 3 : isXs ? 2 : isXxs ? 2 : 1)
    const rows = Math.ceil(streamDefs.length / cols)
    const chipHeight = isMobile ? 22 : 24
    const avatarSize = isMobile ? 14 : 18
    const gap = 6
    const maxRows = isMobile ? 3 : 4
    const maxHeight = maxRows * chipHeight + (maxRows - 1) * gap

    return (
        <Box sx={{ mb: isMobile ? 1 : 2, p: 1.5, bgcolor: 'white', borderRadius: 1, boxShadow: '0 2px 4px rgba(0,0,0,0.08)' }}>
            <Box sx={{
                display: 'grid',
                gridAutoFlow: 'column',
                gridTemplateRows: `repeat(${rows}, auto)`,
                gridTemplateColumns: `repeat(${cols}, 1fr)`,
                gap: 0.75,
                maxHeight,
                overflowY: 'auto'
            }}>
                {streamDefs.map(elem => {
                    const active = streams.has(elem.key)
                    return (
                        <Chip
                            key={elem.key}
                            size="small"
                            avatar={<Box sx={{ borderRadius: '50%', bgcolor: elem.color }} />}
                            label={t(elem.i18nKey)}
                            variant={active ? 'filled' : 'outlined'}
                            onClick={() => onToggle(elem.key)}
                            onDoubleClick={() => onSolo(elem.key)}
                            sx={{
                                height: chipHeight,
                                fontSize: isMobile ? 12 : undefined,
                                cursor: 'pointer',
                                justifyContent: 'flex-start',
                                overflow: 'hidden',
                                '& .MuiChip-avatar': { width: avatarSize, height: avatarSize, minWidth: avatarSize, ml: '4px' },
                                '& .MuiChip-label': { pl: '8px' },
                                ...(active && {
                                    bgcolor: '#e6ecf3',
                                    borderColor: '#003366'
                                })
                            }}
                        />
                    )
                })}
            </Box>
        </Box>
    )
}